
export const fields = [
  "id", "name", "start_date", "end_date", "contractor", "responsible", "contact", "comments",
  "equipment_devices", "cm_devices", "nodes_devices", "telemeasures_devices",
  "contract_price", "node_price", "cm_price", "telemeasures_price", "contract_state"
];


export const mainFields = {
  name: "CONTRATO",
  start_date: "FECHA DE INICIO",
  end_date: "FECHA DE VENCIMIENTO",
  //equipment_devices: "DETALLES DE EQUIPOS",
  cm_devices: "Nº CM",
  nodes_devices: "Nº NODOS",
  telemeasures_devices: "Nº TELEMEDIDAS",
  contract_state: "ESTADO"
};

export const extraFields = {
  responsible: "PERSONA RESPONSABLE",
  contact: "EMAIL Y TELÉFONO",
  comments: "COMENTARIOS",
  equipment_devices: "DETALLES DE EQUIPOS",
  contract_price: "COSTE ANUAL",
  node_price: "PRECIO POR NODO",
  cm_price: "PRECIO POR CM",
  telemeasures_price: "PRECIO POR TELEMEDIDA",
  contractor: "CONTRATISTA",
};
